import { queryOptions } from '@tanstack/react-query';

import { EhrApi } from '@api/EhrApi';

export const patientMobileAppKeys = {
    all: ['patientMobileApp'] as const,
    status: (ehrId: string) => [...patientMobileAppKeys.all, 'status', ehrId] as const,
};

export const patientMobileAppQueryOptions = {
    status: (ehrId: string) =>
        queryOptions({
            queryKey: patientMobileAppKeys.status(ehrId),
            queryFn: () => EhrApi.getMobileAppStatus(ehrId),
            enabled: !!ehrId,
        }),
};
